import React, { Component } from 'react';
import {
  Button,
  FormGroup, Label,
  Input,
  Row, Col,
  Card, CardBody,
} from 'reactstrap';
import { messages } from '../../constants/constant.message';
import TextareaAutosize from 'react-textarea-autosize';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
const { INVALID_EMAIL, EMPTY_EMAIL, EMPTY_PHONE, INVALID_PHONE, INVALID_GST, INVALID_PAN, INVALID_WHATSAPP_NO } = messages.PROFILE;

class EditOtherBusinessDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stateData: [],
      cityData: [],
      state_name: '',
      city_name: '',
      isLoading: false
    }
  }
  handleOnCancel = () => {
    this.props.onCancel('isBusinessEditActive', false);
  }

  componentDidMount() {
    //    this.getState();
  }

  async getState() {
    try {
      const { data } = await AddEditSubsidiariesService.getState();
      let { stateData, state_name } = this.state;
      let { controls } = this.props;
      if (data) {
        stateData = [];
        if (data.data && data.data.length > 0) {
          stateData = data.data;
        }
        this.setState((prevState) => {
          return { ...prevState, stateData, isLoading: false, state_name };
        }, () => {
          this.getCity(controls.state.value);
        });
      }
    } catch (error) {
      this.setState((prevState) => {
        return { ...prevState, isLoading: false };
      });
      console.log(error);
    }
  }

  cityClick(cityData) {
    this.selectedCity = cityData;
    const { controls } = this.state;
    controls.city.value = cityData;
    if (controls.city.value) {
      controls.city.showErrorMsg = false;
    }
    this.setState({ controls });
    // this.props.updateState({ visibleArea: 'vehicleRegistrationNumber', vehicleDetails: { controls, isValidForm } });
  }


  async getCity(controlValue = null) {
    try {
      let { city_name } = this.state;
      const { controls } = this.props;
      if (!controlValue || !controls.state.value) {
        return
      }

      let state_id = controlValue;
      if (controls.state.value && this.state.stateData.length > 0) {
        let state = this.state.stateData.filter(x => x.name.toLowerCase() === controls.state.value.toLowerCase());
        if (state.length > 0) {
          state_id = state[0].state_id;
        } else {
          return
        }
      }
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: true
        };
      });
      const { data } = await AddEditSubsidiariesService.getCity(state_id);
      let { cityData } = this.state;
      cityData = [];
      if (data) {
        if (data.data && data.data.length > 0) {
          cityData = data.data;
          if (controls.city.value && cityData.length > 0) {
            
            let city = cityData.filter(x => x.name.toLowerCase() === controls.city.value.toLowerCase());
            if (city.length <= 0) {
              controls.city.value = '';
            }
          }
        }
      }
      this.setState((prevState) => {
        return {
          ...prevState,
          cityData,
          controls,
          city_name,
          isLoading: false
        };
      });
    } catch (error) {
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: false
        };
      });
      console.log(error);
    }
  }

  stateClick(state) {
    this.selectedState = state;
    const { controls } = this.state;
    controls.state.value = state;
    if (controls.state.value) {
      controls.state.showErrorMsg = false;
    }
    this.getCity();
    this.setState((prevState) => {
      return { ...prevState, controls };
    });
    //this.props.updateState({ visibleArea: 'vehicleSelectCity', vehicleDetails: { controls, isValidForm } });
  }

  handleInputChange = (e) => {
    // let { state_name, city_name } = this.state;
    // const controlName = e.target.name;
    // const controlValue = e.target.value;
  }

  setLoading = (isLoading) => {
    this.setState({
      isLoading: isLoading
    })
  }

  render() {

    const { email, phone, gst, pan, wa } = this.props;
    const { company_name, company_type, owner_name,
      designation, mobile_number, state, city, pin_code, address } = this.props.controls;
    return <Card className={this.props.className}>
      {this.state.isLoading && <CustomSpinner />}
      <CardBody>
        <Row>
          <Col xl="12" md="12" xs="12">
            <b>COMPANY DETAILS</b>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="company_name">Company Name<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="company_name"
                id="company_name"
                value={company_name.value}
                onChange={this.props.handleInputChange}
                autocomplete="nofill"
                placeholder="Enter Company Name" />
              {company_name.showErrorMsg && <div className="error">*Please enter company name.</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="owner_name">Owner Name<span className="required-field">*</span></Label>
              <Input
                type="text"
                autocomplete="nofill"
                name="owner_name"
                id="owner_name"
                onChange={this.props.handleInputChange}
                value={owner_name.value}
                placeholder="Enter Owner Name" />
              {owner_name.showErrorMsg && <div className="error">*Please enter owner name.</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="company_type">Company Type<span className="required-field">*</span></Label>
              <select className="form-control" name="company_type"
                onChange={this.props.handleInputChange} value={company_type.value}
              >
                <option value="" selected disabled>Select company type</option>
                <option value="proprietor">Proprietor</option>
                <option value="partnership">Partnership</option>
                <option value="private limited">Private Limited</option>
                <option value="limited">Limited</option>
              </select>
              {company_type.showErrorMsg && <div className="error">*Please enter company type.</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="designation">Designation<span className="required-field">*</span></Label>
              <Input
                autocomplete="nofill"
                type="text"
                name="designation"
                id="designation"
                className="text-capitalize"
                disabled={true}
                value={designation.value}
                placeholder="" />
              {designation.showErrorMsg && <div className="error">*Please enter designation.</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="pan">Mobile Number <span className="required-field">*</span></Label>
              <Input
                type="text"
                name="mobile_number"
                id="mobile_number"
                className="capital-case"
                value={mobile_number.value}
                maxLength="10"
                onChange={this.props.handleInputChange}
                placeholder="Enter mobile number" />
              {mobile_number.showErrorMsg && <div className="error">*Please enter mobile Number .</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="pan">Whatsapp Number <span className="required-field">*</span></Label>
              <Input
                type="text"
                name="wa"
                id="wa"
                className="capital-case"
                value={wa.value}
                maxLength="10"
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {wa.showErrorMsg && < div className="error">* {INVALID_WHATSAPP_NO}</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="phone">Phone Number <span className="required-field">*</span></Label>
              <Input
                type="text"
                name="phone"
                autoFocus={phone.autoFocus}
                // className="required-input"
                id="phone"
                value={phone.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {phone.showErrorMsg && phone.invalidPhone && <div className="error">* {INVALID_PHONE}</div>}
              {phone.showErrorMsg && phone.nullValue && <div className="error">* {EMPTY_PHONE}</div>}
            </FormGroup>

          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="gst">GST Number</Label>
              <Input
                type="text"
                name="gst"
                id="gst"
                className="capital-case"
                value={gst.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {gst.showErrorMsg && < div className="error">* {INVALID_GST}</div>}
            </FormGroup>

          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="pan">PAN</Label>
              <Input
                type="text"
                name="pan"
                id="pan"
                className="capital-case"
                value={pan.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {pan.showErrorMsg && < div className="error">* {INVALID_PAN}</div>}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="email">Email Address <span className="required-field">*</span></Label>
              <Input
                type="text"
                name="email"
                id="email"
                autoFocus={email.autoFocus}
                // className="required-input"
                // ref={(input) => { this.email = input }}
                value={email.value}
                onChange={this.props.handleInputChange}
                onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'business') : null}
                placeholder="Type here" />

              {email.showErrorMsg && email.invalidEmail && <div className="error">* {INVALID_EMAIL}</div>}
              {email.showErrorMsg && email.nullValue && <div className="error">* {EMPTY_EMAIL}</div>}
            </FormGroup>
          </Col>

          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="address">Address<span className="required-field">*</span></Label>
              <TextareaAutosize
                name="address"
                autocomplete="nofill"
                id="address"
                value={address.value}
                minRows={3}
                maxRows={5}
                style={{ fontSize: '14px' }}
                className="form-control"
                onChange={(e) => this.props.handleInputChange({ target: { name: 'address', value: e.target.value } })}
                placeholder='Enter Address'
              />
              {address.showErrorMsg && <div className="error">*Please enter address.</div>}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="state">State<span className="required-field">*</span></Label>
                  <select className="form-control" name="state"
                    onChange={this.props.handleInputChange} value={state.value}
                  >
                    <option value="" selected="true" disabled>Select state</option>
                    {
                      this.state.stateData && this.state.stateData.map((state) => (
                        <option key={state.name} value={state.name}>{state.name}</option>
                      ))
                    }
                  </select>
                  {state.showErrorMsg && <div className="error">*Please select state.</div>}
                </FormGroup>
              </Col>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="city">City<span className="required-field">*</span></Label>
                  <select className="form-control" name="city"
                    onChange={this.props.handleInputChange} value={city.value ? city.value.toLowerCase() : ''}
                  >
                    <option value="" selected="true" disabled>Select city</option>
                    {
                      this.state.cityData && this.state.cityData.map((city) => (
                        <option key={city.city_id} value={city.name ? city.name.toLowerCase() : ''}>{city.name}</option>
                      ))
                    }
                  </select>
                  {city.showErrorMsg && <div className="error">*Please select city.</div>}
                </FormGroup>
              </Col>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="pin">Pincode<span className="required-field">*</span></Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    value={pin_code.value}
                    name="pin_code"
                    maxLength="6"
                    onChange={this.props.handleInputChange}
                    id="pin_code"
                    placeholder="Enter Pincode" />
                  {pin_code.showErrorMsg && <div className="error">*Please enter pincode.</div>}
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
        {this.props.onSave && <Row>
          <Col xl="12" xs="12" md="12" className="text-align-right" >
            <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" onClick={this.handleOnCancel}>Cancel</Button>
            <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" onClick={this.props.onSave}>Save</Button>
          </Col>
        </Row>}
      </CardBody>
    </Card >;
  }
}

export default EditOtherBusinessDetail;
